import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { List } from 'immutable'
import SelectList from 'components/common/SelectList'
import messages from 'components/Apps/SeaLiceMonitor/translate'
import ArrayHelper from 'helpers/array'
import { setActiveSite } from 'reducers/seaLice/reducer'
import { setSiteContext } from 'reducers/profile/reducer'

class SiteFilter extends Component {
  shouldComponentUpdate(nextProps) {
    if (
      this.props.sitesData !== nextProps.sitesData &&
      nextProps.sitesData.size > 0
    ) {
      if (
        nextProps.activeSite !== 0 &&
        !ArrayHelper.hasInArray(
          nextProps.sitesData.toArray(),
          nextProps.activeSite,
          'site_id',
        )
      ) {
        this.props.setSiteContext({ site: 0 })

        return false
      }
    }

    return true
  }

  onSiteChange = v => {
    const { setActiveSite, activeSite, setSiteContext } = this.props
    if (v) {
      const index = +v.dataKey === 0 ? null : +v.dataKey - 1
      setActiveSite(index)

      if (activeSite !== v.index) setSiteContext({ site: v.index })
    } else {
      setSiteContext({ site: 0 })
    }
  }

  render() {
    const {
      activeSite,
      intl: { formatMessage },
      sitesData,
    } = this.props
    const siteList = [
      {
        site_id: 0,
        site_name: formatMessage(messages.all),
      },
      ...sitesData.toArray(),
    ]

    return (
      <div className="caption-panel site-filter">
        <SelectList
          label={formatMessage(messages.site)}
          className="sealice-table-select"
          name="site"
          onChange={this.onSiteChange}
          list={List(siteList)}
          value={activeSite}
          map={{
            index: 'site_id',
            text: 'site_name',
          }}
        />
      </div>
    )
  }
}

export default connect(
  state => ({
    sitesData: state.getIn(['seaLice', 'sitesData']),
    activeSite: state.getIn(['profile', 'siteId']),
  }),
  {
    setActiveSite,
    setSiteContext,
  },
)(injectIntl(SiteFilter))
